import React from "react";
import setUp from "../../images/setUp.png";
import uniswap from "../../images/uniswap.png";
import Screenshot from "../../images/Screenshot.png";
import monitor from "../../images/monitor.png";

function ExchangeCCRT() {
  const cards = [
    {
      id: 1,
      image: setUp,
      title: "Set up your wallet for polygon",
      bullets: [
        "Configure polygon network",
        "Ensure you have MATIC",
        // third bullet hidden in this card, so we omit
      ],
      // imageLabel: "Screenshot 1",
    },
    {
      id: 2,
      image: uniswap,
      title: "Access the uniswap interface",
      bullets: [
        "Visit the uniswap website ",
        "Connect your wallet",
        "Switch to the polygon network", // third bullet visible
      ],
      imageLabel: "Group 1272628377",
    },
    {
      id: 3,
      image: Screenshot,
      title: "Prepare for swap and execute swap",
      bullets: ["Token approval", "Set up the trade"],
      imageLabel: "Frame 1618873100",
    },
    {
      id: 4,
      image: monitor,
      title: "Monitor transaction",
      bullets: [
        "Check transaction on polygon scan",
        "Confirm success",
      ],
      imageLabel: "Frame 1618873100",
    },
  ];

  return (
    <section
      id="ExchangeToCCRT"
      className="w-full max-w-[1440px] bg-white flex flex-col items-start gap-2.5 mx-auto overflow-hidden px-4 sm:px-8 lg:px-12 py-12 xl:px-[120px] xl:py-[120px]"
    >
      <div className="w-full max-w-[1200px] flex flex-col items-start gap-6 xl:gap-12">
        {/* Header */}
        <div className="w-full max-w-[546px] flex flex-col gap-4">
          <h1 className="font-bold text-[28px] sm:text-[32px] lg:text-[36px] xl:text-[40px] leading-[120%] tracking-[-0.04em] text-[#3B3B3B]">
            Exchange <span className="text-[#0D924F]">CCRT </span>to USDT
          </h1>
          <p className="font-normal text-[16px] sm:text-[18px] leading-[145%] text-[#3B3B3B]">
            Convert your carbon credits to liquidity seamlessly. This is done on the polygon network using Uniswap.
          </p>
        </div>

        {/* Cards row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6 w-full">
          {cards.map((card) => (
            <div
              key={card.id}
              className="relative w-full bg-[#FAFAFA] rounded-lg overflow-hidden hover:shadow-lg transition-shadow cursor-pointer flex flex-col xl:h-[376px] xl:block"
            >
              <img
                className="w-full object-cover"
                src={card.image}
                alt=""
              />

              {/* Text content */}
              <div className="relative px-3 pt-4 pb-5 xl:absolute xl:left-3 xl:top-[196px] xl:w-[calc(100%-24px)] xl:p-0 flex flex-col gap-4">
                <h2 className="font-medium text-[20px] sm:text-[22px] xl:text-[24px] leading-[29px] text-[#141414]">
                  {card.title}
                </h2>
                <div className="flex flex-col gap-2">
                  {card.bullets.map((bullet, idx) => (
                    <p
                      key={idx}
                      className="font-medium text-[16px] leading-[19px] text-[#898989]"
                    >
                      {bullet}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ExchangeCCRT;